import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchAll, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import {
  Button as Btn,
  ButtonGroup,
  CircularProgress,
  Divider,
  Grid,
} from '@mui/material';

import {
  Page,
  StyledButton,
  StyledDateField,
  StyledTextField,
  Typography
} from '../../components/interface';

import {
  BookYear
} from '../../models';

const { DateTime } = require("luxon");

type Props = {};
type RawExportStat = {
  custom_result: any
};

export const OperationsPasta: FunctionComponent<Props> = () => {
  // const navigate = useNavigate();
  const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [startDate, setStartDate] = useState<string>(DateTime.now().toFormat("dd/LL/yyyy"));
  const [step, setStep] = useState<number>(0);
  const [result, setResult] = useState<{
    new_user_count: number;
  }>({
    new_user_count: -1
  });








  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<{
        custom_result: any
      }>(
        '/nl/v3/objects/custom_action',
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setResult(data.custom_result);
    },
  });








  // useEffect(() => {
  //   getBookYears();
  // }, [login]);











  return <Page sx={{}} title="Babetti Spaghetti">
    <Grid container spacing="8">
      <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Typography sx={{
          fontStyle: 'italic'
        }}>Hey Nico, kunt gij nog is ne keer de nieuwe users opzoeken? Thankssssssssss</Typography>
      </Grid>
      {step === 0 && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <StyledButton
          label="En vanaf wanneer?"
          id='fetch_first'
          contained
          onClick={(v) => {
            setStep(1);
          }}
          sx={{
            marginRight: 1
          }}
        />
      </Grid>}
      {step >= 1 && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Typography sx={{
          fontStyle: 'italic',
          fontWeight: 'bold'
        }}>En vanaf wanneer?</Typography>
      </Grid>}
      {step === 1 && <Grid item xs={6}>
        <StyledButton
          label="De laatste emissie he!"
          id='last_emission'
          contained
          onClick={(v) => {
            setStartDate("26/03/2025");
            setStep(2);
          }}
          sx={{
            marginRight: 1
          }}
        />
      </Grid>}
      {step === 1 && <Grid item xs={3}>
        <StyledDateField
          label="StartDate"
          value={startDate || ''}
          id='startDate'
          onChange={(v) => {
            setStartDate(v.toString());
          }}
          fullWidth
        />
      </Grid>}
      {step === 1 && <Grid item xs={3}>
        <StyledButton
          label="Vanaf hier"
          id='last_emission'
          contained
          onClick={(v) => {
            setStep(2);
          }}
          sx={{
            marginRight: 1
          }}
        />
      </Grid>}
      {step >= 2 && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Typography sx={{
          fontStyle: 'italic',
        }}>{startDate === "26/03/2025" && "De laatste emissie he!"}{startDate !== "26/03/2025" && `Vanaf ${startDate}`}</Typography>
      </Grid>}
      {step === 2 && <Grid item xs={12}>
        <StyledButton
          label="Alright"
          id='fetch_alright'
          contained
          onClick={(v) => {
            setStep(3);
            mutationCustomAction.mutate({
              formData: {
                object: 'operations',
                class_action: 'custom_api_babs_vragen',
                start_date: startDate
              }
            });
          }}
          sx={{
            marginRight: 1
          }}
        />
      </Grid>}
      {step >= 3 && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Typography sx={{
          fontStyle: 'italic',
          fontWeight: 'bold'
        }}>Alright</Typography>
      </Grid>}
      {step >= 3 && result.new_user_count > -1 && <Grid item xs={12} sx={{textAlign: 'center'}}>
        <Typography sx={{
          fontStyle: 'italic',
          fontWeight: 'bold'
        }}>Het aantal nieuwe gebruikers is <span style={{fontSize: '1.3rem'}}>{result.new_user_count}</span> man.</Typography>
      </Grid>}




      {!!mutationCustomAction.isPending && <Grid item xs={12}>
        <CircularProgress />
      </Grid>}

      <Grid item xs={12} sx={{textAlign: 'center', marginTop: 8}}>
        <Divider />
        <StyledButton
          label="(IT) Levi 200 age excel"
          id='levi_200'
          contained
          onClick={(v) => {
            mutationCustomAction.mutate({
              formData: {
                object: 'operations',
                class_action: 'custom_api_levi200'
              }
            });
          }}
          sx={{
            marginTop: 2
          }}
        />
      </Grid>
    </Grid>
  </Page>;
}
